/* unplugin-vue-components disabled */import { render } from "./pointdata.vue?vue&type=template&id=080c8a46&scoped=true"
import script from "./pointdata.vue?vue&type=script&lang=js"
export * from "./pointdata.vue?vue&type=script&lang=js"

import "./pointdata.vue?vue&type=style&index=0&id=080c8a46&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-080c8a46"]])

export default __exports__